import React from 'react';
import { ChevronRightFilled } from '@/components/Icons/ChevronRightFilled';
import { formatDate } from '@/utils/date';
import { tv } from '@/utils/tv';

interface Props {
  label: string;
  value: Date | null;
  hasError?: boolean;
  hasChevron?: boolean;
  isActive?: boolean;
  onClick: () => void;
}

const field = tv({
  base: 'flex h-14 w-full flex-1 cursor-pointer items-center gap-2 rounded-xl border text-left transition-colors',
  variants: {
    hasError: {
      true: 'border-destructive',
      false: 'border-transparent',
    },
    hasChevron: {
      true: 'pr-3 pl-4',
      false: 'px-3',
    },
    isActive: {
      true: 'bg-secondary-pressed',
      false: 'bg-on-primary-surface hover:bg-on-primary-surface/80',
    },
  },
});

export const AbsenceDateField: React.FC<Props> = ({
  label,
  value,
  hasError = false,
  hasChevron = false,
  isActive = false,
  onClick,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={field({ hasError, hasChevron, isActive })}
  >
    <span className="flex min-w-0 flex-1 flex-col justify-center gap-0.5">
      {value && (
        <>
          <span className="text-caption-12 text-muted-foreground">{label}</span>
          <span className="truncate text-callout-16 text-foreground">
            {formatDate(value.toISOString())}
          </span>
        </>
      )}
      {!value && (
        <span className="text-body-16 text-muted-foreground">{label}</span>
      )}
    </span>
    {hasChevron && (
      <ChevronRightFilled className="size-4 shrink-0 text-muted-foreground" />
    )}
  </button>
);
